"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import Link from "next/link";
import ArtistPill from "./ArtistPill";
interface NowMintingHeaderProps {
  readonly cardNumber: number;
  readonly title: string;
  readonly artistHandle: string;
  readonly artistName: string;
  readonly mediaMimeType?: string | null | undefined;
}
export default function NowMintingHeader(t0) {
  const $ = _c(28);
  const {
    cardNumber,
    title,
    artistHandle,
    artistName,
    mediaMimeType
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== artistHandle || $[1] !== artistName || $[2] !== cardNumber || $[3] !== mediaMimeType || $[4] !== title) {
    const artistHandles = artistHandle.split(",").map(_temp).filter(Boolean);
    t5 = "tw-flex tw-flex-col";
    const t7 = `/the-memes/${cardNumber}`;
    if ($[11] !== t7 || $[12] !== title) {
      t6 = <Link href={t7} className="tw-text-xl tw-font-semibold tw-leading-tight tw-text-iron-50 tw-no-underline tw-transition-colors tw-duration-300 desktop-hover:hover:tw-text-iron-200 sm:tw-text-2xl md:tw-text-3xl">{title}</Link>;
      $[11] = t7;
      $[12] = title;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t1 = "tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-gap-2";
    if ($[14] !== cardNumber || $[15] !== mediaMimeType) {
      t2 = mediaMimeType && <MediaTypeBadge mimeType={mediaMimeType} dropId={`home-now-minting-${cardNumber}`} size="sm" iconClassName="tw-size-[26px]" />;
      $[14] = cardNumber;
      $[15] = mediaMimeType;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    if ($[17] !== cardNumber) {
      t3 = <span className="tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-[0.08em] tw-text-iron-400 tw-backdrop-blur-sm">Card #{cardNumber}</span>;
      $[17] = cardNumber;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    t4 = artistHandles.length > 0 ? artistHandles.map(_temp2) : <ArtistPill label={artistName} />;
    $[0] = artistHandle;
    $[1] = artistName;
    $[2] = cardNumber;
    $[3] = mediaMimeType;
    $[4] = title;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4) {
    t7 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp2(handle_0) {
  return <ArtistPill key={handle_0} label={handle_0} href={`/${handle_0}`} profileHandle={handle_0} />;
}
function _temp(handle) {
  return handle.trim();
}